import { useState, VFC } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { asModal, ModalProps } from 'src/components/hoc/asModal'
import styled from 'styled-components'
import { Button, ButtonsDiv, CancelButton, Layout } from './styles'

type ScheduleMessageUpdateProps = {
  text: string
  update: (text: string) => void
}
const ScheduleMessageUpdate: VFC<ModalProps<ScheduleMessageUpdateProps>> = ({
  close,
  ...props
}) => {
  const [text, setText] = useState(props.text)
  return (
    <StyledLayout>
      <h3>予約送信内容を編集する</h3>
      <textarea
        value={text}
        onChange={({ target: { value } }) => setText(value)}
      />
      <ButtonsDiv>
        <CancelButton onClick={close}>キャンセル</CancelButton>
        <Button
          onClick={() => {
            props.update(text)
            close()
          }}
        >
          送信内容を更新
        </Button>
      </ButtonsDiv>
    </StyledLayout>
  )
}
export const ScheduleMessageUpdateModal = asModal(ScheduleMessageUpdate)

const StyledLayout = styled(Layout)`
  textarea {
    margin: 32px 16px 0;
    text-align: left;
    width: 428px;
    height: 287px;
    resize: none;
  }
`
